module.exports = __webpack_public_path__ + "static/media/Precepts translated by J_lee_77777.3a537ac4.txt";